<template>
  <div>
    <el-button
      type="primary"
      size="small"
      @click="handleEdit()"
      v-code="51301"
      v-if="admin"
    >
      添加出库单
    </el-button>
    <el-table :data="list">
      <el-table-column label="出库单号" align="center" prop="number">
      </el-table-column>
      <el-table-column label="部门" align="center" prop="department">
      </el-table-column>
      <el-table-column label="出库类型" align="center">
        <template slot-scope="scope">{{
          ItemStockOutCategoryMap[scope.row.category]
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="钻头">
        <template slot-scope="scope">
          <div
            v-for="no in scope.row.drill_serial_numbers.split(',')"
            :key="no"
            v-if="scope.row.drill_serial_numbers"
          >
            <DrillLink :no="no"></DrillLink>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="备注"
        prop="remark"
      ></el-table-column>
      <el-table-column label="出库日期" align="center">
        <template slot-scope="scope">
          {{ scope.row.confirm_time || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" type="primary">{{
            OutboundOrderStatusMap[scope.row.status]
          }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="总成本" align="center">
        <template slot-scope="scope">
          {{ scope.row.settle_status ? scope.row.amount.toFixed(2) : '未结算' }}
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <el-popconfirm
            v-if="admin && !scope.row.confirm_time"
            v-code="51301"
            title="确认删除该出库单吗？"
            @confirm="handleDelete(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="danger"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            v-code="51301"
            :underline="false"
            v-if="admin && scope.row.status == 1"
            class="ml-10"
            type="primary"
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-link
          >
          <el-link
            v-code="51301"
            :underline="false"
            class="ml-10"
            plain
            type="primary"
            @click="$router.push(`${$route.path}/${scope.row.id}`)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <editor
      :model="model"
      :show.sync="formerVisible"
      @callback="callback"
    ></editor>
  </div>
</template>

<script>
import { outboundOrderDelete } from '@/service/getData'
import {
  OutboundOrderStatusMap,
  ItemStockOutCategoryMap,
} from '@/config/global'
import editor from './editor'
import { getStore } from '@/config/mUtils'

export default {
  components: {
    editor,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      admin: getStore('userInfo').is_stockroom_admin,
      OutboundOrderStatusMap,
      ItemStockOutCategoryMap,
      formerVisible: false,
      editIndex: -1,
      model: {},
    }
  },
  methods: {
    handleEdit(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          department: '',
          category: 1,
          belong_month: 1,
          drills: [],
          bookkeeper: '',
          remark: '',
          items: [],
          created: true,
        }
      } else {
        this.model = this.clone(item)
        this.model.drills = item.drill_serial_numbers
          ? item.drill_serial_numbers.split(',')
          : []
        this.model.created = true
        this.editIndex = index
      }
      this.formerVisible = true
    },
    async handleDelete(id, index) {
      let res = await outboundOrderDelete(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },

    callback(data) {
      if (this.editIndex == -1) {
        this.list.unshift(data)
      } else {
        this.$set(this.list, this.editIndex, data)
      }
    },
  },
}
</script>